import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/mir.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/mobile.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/sber.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/sbp.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/tinkoff.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/icons/vk.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/dzen.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/odnoklassniki.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/ula.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/vk-cloud.svg");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/dev-landing/src/img/tools/vk-mail.svg");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollTarget"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/analytics/components/ScrollTarget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["logBreadcrumbsClick"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/analytics/helpers/logBreadcrumbsClick.ts");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/layouts/PageLayout.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/layouts/PageViewLogger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProStoreArticles"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/proStore/ProStoreArticles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProstoreSelectionsView"] */ "/builds/RuStore-Web/monoland/apps/vk-store-web-landing/src/page_components/proStore/ProstoreSelectionsView.tsx");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/shared/NewPagination/DirectionButton.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/shared/NewPagination/NewPagination.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/shared/NewPagination/PageButton.module.scss");
;
import(/* webpackMode: "eager" */ "/builds/RuStore-Web/monoland/packages/shared/PageLoader/PageLoader.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumbs"] */ "/builds/RuStore-Web/monoland/packages/ui-kit/src/Breadcrumbs/Breadcrumbs.tsx");
